import { render, staticRenderFns } from "./BalanceMoneyMenuItem.vue?vue&type=template&id=da4563c2&scoped=true"
import script from "./BalanceMoneyMenuItem.vue?vue&type=script&lang=js"
export * from "./BalanceMoneyMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4563c2",
  null
  
)

export default component.exports